import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http";
import Chart from 'react-apexcharts';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_kratos';
import NoData from "../../NoData";
import ChartLoader from '../../ChartLoader';
import WaterMark from "../../DashboardMain_Kratos/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import CommanBarTable_Kratos from "../CommanBarTable_Kratos";

// ];
let Maxchartdata
let res_result = []

const CandlestickChart_Kratos = ({ apiend, gloablfilter, type, chartnameFCD, chartType_option }) => {
  const [chartdata, setChartData] = useState([]);
  const [series, setseries] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState(chartnameFCD);
  let barcolor = "#83A4CF"

  const options = {
    chart: {
      type: 'candlestick',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false, // Set to false to hide the entire toolbar
        tools: {
          download: true, // Set to true/false to show/hide specific buttons
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
        },
      },
    },
    grid: {
      show: false,      // you can either change hear to disable all grids
    },

    xaxis: {
      type: 'decimal', // Set x-axis type to numeric
      tooltip: {
        enabled: false, // Disable x-axis tooltip
      },
      title: {
        text: 'Charging Cycle',
        offsetY: 90,
        style: {
          fontWeight: 'normal', // 'normal' or 'bold'
        },
      },
      labels: {
        rotate: 0,
        hideOverlappingLabels: true,
      }
    },

    yaxis: [{
      title: {
        text: 'Soc(%)',
        style: {
          fontWeight: 'normal', // 'normal' or 'bold'
        },
      },
      min: 0,
      max: 100,
    }],

    plotOptions: {
      candlestick: {
        colors: {
          upward: '#3578b0', // Color for rising candles (green)
          downward: '#3578b0', // Color for falling candles (red)
        },
      },
    },

    tooltip: {
      enabled: true,
      custom: ({ seriesIndex, dataPointIndex, w }) => {
        const open = w.globals.seriesCandleO[seriesIndex][dataPointIndex];
        const close = w.globals.seriesCandleC[seriesIndex][dataPointIndex];

        return `
          <div>
            <span>cycles: ${dataPointIndex + 1}</span>
            <br>
            <span>soc_end: ${open}</span>
            <br>
            <span>soc_start: ${close}</span>
          </div>
        `;
      },
    },

  };

  const [dataHash, setDataHash] = useState([])

  const appyDataVehicles = (data) => {
    setDataHash(data);
  }

  useEffect(() => {
    barcolor = "#83A4CF"
    SetChartName(chartnameFCD);
    fetchData({ url: API_URL_MAIN + "kratos_charge/" + apiend, body: { filterdata: gloablfilter } }, appyDataVehicles)
  }, [gloablfilter, type, chartType_option])

  useEffect(() => {
    const seriesN = [
      {
        data: dataHash.map((item, index) => ({
          x: index + 1, // Use numerical values for x-axis
          y: [item.soc_end, item.soc_end_o, item.soc_start, item.soc_start_o],
        })),
      },
    ];

    setseries(seriesN);
  }, [dataHash])

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {
                (isLoading) ? <ChartLoader /> : ((series.length > 0) ?
                  <Chart options={options} series={series} type="candlestick" width="650px" height="350px" />
                  : <NoData />
                )}
            </div>
          </div>
        </div>
      </div>

      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>
      <WaterMark />

      {(isLoading) ? <ChartLoader /> : ((series.length > 0) ?
        <Chart options={options} series={series} type="candlestick" height="210px" /> : <NoData />)}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                  <tr>
                    <th scope="col">Vin Number</th>
                    <th scope="col">value</th>
                  </tr></thead>
                <tbody>
                  <CommanBarTable_Kratos data={filteredData} tabDataKey={"gunDurationInMin"} />
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
    </>
  );

};

export default CandlestickChart_Kratos;